var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "verification" },
    [
      _c("div", { staticClass: "container-header" }, [
        _c("div", { staticClass: "container-header__title" }, [
          _vm._v(" " + _vm._s(_vm.i18n.lbl_verification()))
        ])
      ]),
      _vm._v(" "),
      !_vm.selectedUserType
        ? _c("user-type-selector", {
            on: { onVerification: _vm.handleUserType }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedUserType
        ? [
            _vm.accountState === _vm.ACCOUNT_STATES.approved &&
            !_vm.showForm &&
            (_vm.accountKycLatestRequest.accountTypeToSet ===
              _vm.userTypes.general ||
              _vm.accountKycLatestRequest.accountTypeToSet ===
                _vm.userTypes.syndicate)
              ? [
                  _c("approved-banner", {
                    attrs: { userType: _vm.selectedUserType }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.accountState === _vm.ACCOUNT_STATES.pending
              ? [
                  _c("state-banner"),
                  _vm._v(" "),
                  _vm.selectedUserType === _vm.userTypes.general
                    ? [_c("individual-form")]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedUserType === _vm.userTypes.syndicate
                    ? [_c("syndicate-form")]
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.accountState === _vm.ACCOUNT_STATES.rejected
              ? [
                  _c("div", { staticClass: "container container_40 banner" }, [
                    _c(
                      "div",
                      { staticClass: "verification__card-message" },
                      [
                        _c(
                          "md-icon",
                          {
                            staticClass:
                              "md-size-4x verification__card-message-icon"
                          },
                          [_vm._v("warning")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "banner__title text_large" }, [
                          _vm._v(_vm._s(_vm.i18n.kyc_rejected_title()))
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "banner__description",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.i18n.kyc_rejected_msg_html({
                                reason: _vm.accountKycLatestRequest.rejectReason
                              })
                            )
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-wrap" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "btn md-primary",
                            on: {
                              click: function($event) {
                                _vm.showForm = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.i18n.lbl_edit_details()))]
                        )
                      ],
                      1
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.accountState === _vm.ACCOUNT_STATES.nil ||
            _vm.showForm ||
            _vm.accountKycLatestRequest.accountTypeToSet ===
              _vm.userTypes.not_verified
              ? [
                  _vm.selectedUserType === _vm.userTypes.general
                    ? [_c("individual-form")]
                    : _vm.selectedUserType === _vm.userTypes.syndicate
                    ? [_c("syndicate-form")]
                    : _vm._e()
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8173df98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8173df98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/verification/make/Verification.Make.vue
// module id = j0n6
// module chunks = 1